module.exports = "https://cdn.redage.net/src/views/donate/main/elements/shop/img/buy.svg";